import { render, staticRenderFns } from "./OsRating.vue?vue&type=template&id=36a58e48&scoped=true&"
import script from "./OsRating.vue?vue&type=script&lang=js&"
export * from "./OsRating.vue?vue&type=script&lang=js&"
import style0 from "./OsRating.vue?vue&type=style&index=0&id=36a58e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a58e48",
  null
  
)

export default component.exports